let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fZz1O")).then(() => parcelRequire('jEc6C'));